import { useEffect, useState } from "react";
import api from "@/lib/api";
import { MapTrifold } from "@phosphor-icons/react";

const LEVEL_LABELS = {
  distrito: "Distritos",
  municipio: "Municipios",
  gau: "GAU",
};

export default function Zonification() {
  const [zones, setZones] = useState([]);
  const [level, setLevel] = useState("distrito");

  useEffect(() => {
    api.get(`/zones?level=${level}&limit=2000`).then(({ data }) => setZones(data.zones));
  }, [level]);

  return (
    <div className="h-full overflow-auto px-10 py-10">
      <div className="max-w-5xl">
        <p className="label-micro text-[#FF9800] mb-2 flex items-center gap-2">
          <MapTrifold size={14} weight="bold" /> ZONIFICACIÓN
        </p>
        <h1 className="text-4xl font-bold tracking-tight">Niveles disponibles</h1>
        <p className="text-white/50 text-sm mt-2 max-w-2xl">
          La aplicación trabaja con tres niveles de zonificación inspirados en
          los datasets oficiales del MITMA. Selecciona uno para ver las zonas
          incluidas.
        </p>

        <div className="mt-6 flex gap-2">
          {Object.entries(LEVEL_LABELS).map(([id, label]) => (
            <button
              key={id}
              onClick={() => setLevel(id)}
              className={`px-4 py-2 text-sm border ${
                level === id
                  ? "border-[#FF9800] bg-[#FF9800]/10 text-[#FF9800]"
                  : "border-white/10 text-white/60 hover:text-white"
              } btn-press`}
              data-testid={`level-${id}`}
            >
              {label} · {level === id ? zones.length : "—"}
            </button>
          ))}
        </div>

        <div className="mt-8 border border-white/10 bg-[#121212]">
          <table className="w-full text-sm">
            <thead className="bg-[#0A0A0A]">
              <tr className="border-b border-white/10">
                <th className="text-left px-4 py-3 label-micro">ID</th>
                <th className="text-left px-4 py-3 label-micro">NOMBRE</th>
                <th className="text-left px-4 py-3 label-micro">PROVINCIA</th>
                <th className="text-right px-4 py-3 label-micro">POBLACIÓN</th>
              </tr>
            </thead>
            <tbody>
              {zones.map((z) => (
                <tr key={z.id} className="border-b border-white/5 hover:bg-white/[0.03]">
                  <td className="px-4 py-2 font-mono text-xs text-white/50">{z.id}</td>
                  <td className="px-4 py-2 text-white">{z.name}</td>
                  <td className="px-4 py-2 text-white/60">{z.province}</td>
                  <td className="px-4 py-2 text-right font-mono text-white/70">
                    {z.population?.toLocaleString("es-ES") || "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
